import { initState } from './index';

export default {
  reset(state) {
    Object.assign(state, initState());
  },
  setError(state, error) {
    state.error = error;
  },
  setLoading(state, payload) {
    state.isLoading = payload;
  },
  setSaving(state, payload) {
    state.isSaving = payload;
  },
  setCdd(state, payload) {
    state.cdd = payload;
  },
  setQuestionnaire(state, payload) {
    state.questionnaire = payload;
  },
  setStates(state, payload) {
    state.states = payload;
  },
  setCustomer(state, payload) {
    const sectionIndex = findSectionIndex(state, 'section_a');
    if (sectionIndex === -1) {
      return;
    }
    state.cdd.sections[sectionIndex].customer = payload;
  },
  setSectionValue(state, payload) {
    const sectionIndex = findSectionIndex(state, payload.sectionId);
    if (sectionIndex === -1) {
      return;
    }
    const index = state.cdd.sections[sectionIndex].items.findIndex(
      (item) => item.id === payload.id,
    );
    if (index === -1) {
      return;
    }
    state.cdd.sections[sectionIndex].items[index].value = payload.value;
  },
};

const findSectionIndex = (state, id) => {
  if (!state.cdd) {
    return -1;
  }
  return state.cdd.sections.findIndex((section) => section.id === id);
};
